import { render, staticRenderFns } from "./printSetOrderLabels.vue?vue&type=template&id=85965024&scoped=true&"
import script from "./printSetOrderLabels.vue?vue&type=script&lang=js&"
export * from "./printSetOrderLabels.vue?vue&type=script&lang=js&"
import style0 from "./printSetOrderLabels.vue?vue&type=style&index=0&id=85965024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85965024",
  null
  
)

component.options.__file = "printSetOrderLabels.vue"
export default component.exports